import type { Team } from '@/types/team.types';

type HIWorkOrderAccessUser = {
  roleId: string;
  userId: string;
  teams: Pick<Team, 'key' | 'supervisorId'>[];
};

const HOME_INSPECTION_TEAM_KEY = 'SERVICE';

export const isHomeInspectionServiceTeamMember = (user: HIWorkOrderAccessUser | null | undefined): boolean => {
  return user?.teams.some((team) => team.key === HOME_INSPECTION_TEAM_KEY) ?? false;
};

export const canAccessHomeInspectionWorkOrders = (user: HIWorkOrderAccessUser | null | undefined): boolean => {
  if (!user) return false;

  return (
    user.roleId === 'ADMIN' ||
    user.teams.some((team) => team.supervisorId === user.userId) ||
    isHomeInspectionServiceTeamMember(user)
  );
};
